/**
 * Adds btn--loading to the submit button when a form with [data-submit-loading] is submitted.
 * Works with native form submissions (full page reload).
 */
document.addEventListener('submit', (e) => {
  const form = e.target.closest('[data-submit-loading]');
  if (!form) return;
  const btn = form.querySelector('[type="submit"]');
  btn?.classList.add('btn--loading');
});

export class EmailSignupPreferences extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('.email-signup__form');
    if (!this.form) return;

    this.hiddenNoteInput = this.querySelector('.email-signup__preferences-note');
    this.preferenceCheckboxes = this.querySelectorAll('.email-signup__preferences-checkbox');
    if (!this.hiddenNoteInput || this.preferenceCheckboxes.length === 0) return;

    this.boundUpdatePreferenceNote = this.updatePreferenceNote.bind(this);

    this.updatePreferenceNote();
    this.preferenceCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.boundUpdatePreferenceNote);
    });
  }

  disconnectedCallback() {
    if (!this.boundUpdatePreferenceNote) return;

    this.preferenceCheckboxes?.forEach((checkbox) => {
      checkbox.removeEventListener('change', this.boundUpdatePreferenceNote);
    });
  }

  updatePreferenceNote() {
    const selectedPreferences = Array.from(this.preferenceCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value.trim())
      .filter((value) => value.length > 0);

    const notePrefix = this.dataset.notePrefix;

    this.hiddenNoteInput.value = selectedPreferences.length > 0
      ? `${notePrefix ? `${notePrefix}: ` : ''}${selectedPreferences.join(', ')}`
      : '';
  }
}

if (!customElements.get('email-signup-preferences')) {
  customElements.define('email-signup-preferences', EmailSignupPreferences);
}

/**
 * Custom select element.
 * Tracks filled state by toggling form__select--is-filled on the native <select>.
 */
export class SelectCustom extends HTMLElement {
  /** @type {HTMLSelectElement} */
  get select() {
    const select = this.querySelector('select');
    if (!(select instanceof HTMLSelectElement)) throw new Error('Select element not found');
    return select;
  }

  connectedCallback() {
    this.boundHandleSelectChange = this.handleSelectChange.bind(this);
    this.select.addEventListener('change', this.boundHandleSelectChange);
    this.handleSelectChange();
  }

  disconnectedCallback() {
    if (this.boundHandleSelectChange) {
      this.select.removeEventListener('change', this.boundHandleSelectChange);
    }
  }

  handleSelectChange() {
    this.select.classList.toggle('form__select--is-filled', !!this.select.value);
  }
}

if (!customElements.get('select-custom')) {
  customElements.define('select-custom', SelectCustom);
}
